import snukReducer from './snukReducer';

const halls = (state, action) => snukReducer(state, action, 'halls');

export default halls;



// WEBPACK FOOTER //
// ./src/reducers/halls.js